import type { RxCollection } from "rxdb"
import { useRxCollection } from "rxdb-hooks"
import { userEntryCollectionKey } from "src/schema"
import type { UserEntry } from "src/types"

export function useUserEntriesCollection(): RxCollection<UserEntry> | null {
  return useRxCollection<UserEntry>(userEntryCollectionKey)
}
